/**
 * lib/env/envContext.ts — contexto + hook de entorno (sin componentes, para fast-refresh).
 */
import { createContext, useContext } from 'react'
import {
  detectEnvironment,
  type EnvInfo,
  type AnalyticsCapability,
  type EnvBlockReason,
} from './environment'

export interface EnvContextValue {
  env: EnvInfo
  analytics: AnalyticsCapability
  /** Motivo de bloqueo TOTAL de la app (cruce de entorno / host / no verificable). */
  block: EnvBlockReason | null
  refreshCapability: () => void
}

export const EnvContext = createContext<EnvContextValue | null>(null)

export function useEnvironment(): EnvContextValue {
  const ctx = useContext(EnvContext)
  if (!ctx) {
    return {
      env: detectEnvironment(),
      analytics: { status: 'loading' },
      block: null,
      refreshCapability: () => {},
    }
  }
  return ctx
}
